// src/constants/accountDeletion.js
//
// Ștergerea unui cont (elev sau personal) e logică, pe backend
// (DELETE /users/{id}): contul dispare din liste și nu se mai poate conecta,
// istoricul rămâne. Adminul poate șterge orice cont în afară de al lui;
// managerul nu poate șterge admini sau manageri.

export const ACCOUNT_DELETE_CONFIRM_TITLE =
   "Șterge contul (ștergere logică, cu păstrarea istoricului)";
